
import downloadFile from '@/utils/downloadFile';
import { getAccountData } from '@/services/Settings/Api';
import {
  computed, defineComponent, ref
} from 'vue';
import useSettings from '@/state/settingsState';
import EditIcon from '@/components/molecules/EditIcon.vue';
import LegalButton from '@/views/settings/components/utils/LegalButton.vue';
import { AffiliateContract } from '@/models/Affiliate';
import { getAffiliateContract } from '@/services/AffiliateService';
import usePopupState from '@/state/usePopupState';
import useI18n from '@/mixins/useI18n';

export default defineComponent({
  name: 'SectionLegal',
  components: { EditIcon, LegalButton },
  setup() {
    const { settings, showDeleteAccountPopup } = useSettings();
    const { t } = useI18n();
    const affiliateDownload = ref<AffiliateContract | null>(null);
    const isLoadingAffiliateContract = ref(false);
    const { setPdf, showPopup, hidePopup } = usePopupState();

    const donwloadAfiliateContract = async () => {
      if (isLoadingAffiliateContract.value) return;

      try {
        isLoadingAffiliateContract.value = true;
        showPopup();
        const contract = affiliateDownload.value ?? await getAffiliateContract();
        affiliateDownload.value = contract;
        setPdf(contract.attachment, contract.filename);
      } catch (error) {
        hidePopup();
        console.error('View affiliate contract failed', error);
      } finally {
        isLoadingAffiliateContract.value = false;
      }
    };

    const consentSettings = computed(() => settings.value?.consentObjectSettings);
    const affiliateConsent = computed(() => consentSettings.value?.affiliateContract ?? null);
    const affiliateVersion = computed(() => (
      affiliateConsent.value ? `${t('settings.legal.version')} ${affiliateConsent.value.version}` : ''
    ));

    const deleteAccount = () => {
      showDeleteAccountPopup.value = true;
    };

    const isDownloadingAccountData = ref(false);

    const downloadAccountData = async () => {
      isDownloadingAccountData.value = true;
      const data = await getAccountData();
      if (data) {
        downloadFile(data.attachment, data.filename, data.fileType);
      }
      isDownloadingAccountData.value = false;
    };

    return {
      deleteAccount,
      downloadAccountData,
      consentSettings,
      donwloadAfiliateContract,
      affiliateConsent,
      affiliateVersion,
      isLoadingAffiliateContract,
      isDownloadingAccountData
    };
  }
});
